/**
 * SEO keywords tuned to outrank competitors (pickuprentaltruck.com, pickuptruckrentaluae.com).
 * Focus: Dubai-specific, long-tail, intent-based (rental, moving, same-day, with driver), and location.
 */

/** Primary + long-tail keywords for homepage and general pages */
export const SEO_KEYWORDS = {
  /** From GSC: pickup truck rental dubai (top clicks), pickup rental dubai (471 imp), truck rental dubai, pickup for rent in dubai. */
  default:
    'pickup truck rental dubai, pickup rental dubai, pickup truck rental in dubai, truck rental dubai, truck rental in dubai, ' +
    'pickup for rent in dubai, pickup truck for rent in dubai, 1 ton pickup for rent in dubai, 3 ton pickup for rent in dubai, 7 ton pickup for rent in dubai, 10 ton pickup for rent in dubai, ' +
    '1 ton pickup truck rental dubai, 3 ton pickup truck rental dubai, 1 ton truck rental dubai, rent a pickup truck, rent a truck dubai, rent a pickup in dubai, ' +
    'pickup rental truck dubai, tail lift truck rental, book pickup truck, pickup rental in dubai, home shifting dubai, office moving dubai, ' +
    'dubai marina truck rental, JVC movers dubai, business bay moving',

  /** Services listing page */
  services:
    'pickup truck rental services dubai, truck rental dubai 1 to 10 ton, tail lift pickup rental dubai, ' +
    'house shifting services dubai, office relocation dubai, furniture moving dubai, cargo transport dubai, ' +
    'same day pickup truck dubai, truck with driver dubai',

  /** About page */
  about:
    'pickup truck rental company dubai, trusted truck rental dubai, professional movers dubai, ' +
    'pickup rental truck dubai about',

  /** Contact page */
  contact:
    'contact pickup truck rental dubai, book truck dubai, truck rental quote dubai, 0543507981',

  /** Per truck size – include "X ton pickup for rent in dubai" (high impressions in GSC). */
  truck: (ton: string) =>
    `${ton} ton pickup for rent in dubai, ${ton} ton pickup truck rental dubai, ${ton} ton truck rental dubai, ` +
    `${ton} ton truck dubai, ${ton} ton pickup truck rental, tail lift truck rental`,

  /** Blog listing */
  blog:
    'pickup truck rental blog dubai, moving tips dubai, truck rental guide dubai',

  /** Blog posts */
  blogRentalGuide:
    'pickup truck rental guide dubai, how to rent truck dubai, truck sizes dubai, truck rental tips dubai',
  blogMoversPackers:
    'best movers and packers dubai, movers and packers dubai 2025, home shifting dubai, office movers dubai',
} as const;

/** Max lengths: title 50–60 chars, description 150–160 chars (Google truncates beyond). */
export const SEO_MAX_TITLE = 60;
export const SEO_MAX_DESCRIPTION = 160;

/** Default meta description (≤160 chars). Covers top GSC queries: pickup truck rental dubai, pickup rental dubai, truck rental dubai. */
export const SEO_DEFAULT_DESCRIPTION =
  'Pickup truck rental Dubai & pickup for rent in Dubai. 1–10 ton trucks with tail lift. Truck rental Dubai for home shifting, office moving. 24/7. Call 0543507981.';

/** Homepage title (≤60 chars). Top query = "pickup truck rental dubai" (261 imp, 16 clicks). */
export const SEO_DEFAULT_TITLE = 'Pickup Truck Rental Dubai 0543507981 | Home Shifting & Moving';
